import cn from "classnames";
import { brown } from "@/app/font";

import { ArrowRightIcon } from "@/components/icons/arrowRight.icon";
import {
  ICON_REGISTRY,
  isFrontendIconName,
} from "@/components/icons/iconRegistry";

import { resolveLinkHref } from "@/utils/url.util";

import { SpotlightHeroProps } from "./spotlightHero.component";

export const SpotlightHeroAction = ({ block }: SpotlightHeroProps) => {
  return block.actions?.map((action) => {
    const Icon =
      action.icon && isFrontendIconName(action.icon)
        ? ICON_REGISTRY[action.icon].Icon
        : null;

    return (
      <a
        key={action._key}
        href={resolveLinkHref(action.link)}
        target={action.link?.openInNewTab ? "_blank" : undefined}
        rel={action.link?.openInNewTab ? "noopener noreferrer" : undefined}
        className="group bg-primary-100 text-secondary hover:border-primary-400 active:bg-primary-100 flex min-h-28 flex-row items-center gap-4 rounded-2xl border-2 border-[#5DCDFF] px-5 py-4 no-underline shadow-[0_6px_20px_0_rgba(0,10,36,0.28)] backdrop-blur-[10px] transition hover:bg-white hover:shadow-[0_8px_28px_0_rgba(0,10,36,0.34)] focus-visible:ring-[3px] focus-visible:ring-[#00226A] focus-visible:outline-none active:border-[#5DCDFF] active:shadow-none">
        {Icon ? (
          <span className="text-secondary flex size-10 shrink-0 items-center justify-center rounded-full bg-white shadow-[0_0_18px_rgba(93,205,255,0.32)]">
            <Icon width={22} height={22} aria-hidden />
          </span>
        ) : null}
        <span className="flex min-w-0 flex-1 flex-col justify-center pr-5 lg:pr-8">
          <span
            className={cn(
              "block text-lg leading-tight font-bold lg:text-xl",
              brown.className,
            )}>
            <span className="lg:hidden">
              {action.mobileTitle || action.title}
            </span>
            <span className="hidden lg:inline">{action.title}</span>
          </span>
          <span
            className={cn(
              "mt-1 flex items-center gap-2 text-sm lg:text-base",
              action.emphasized
                ? "text-primary underline underline-offset-4"
                : "text-secondary",
            )}>
            <span className="lg:hidden">
              {action.mobileLinkLabel || action.linkLabel}
            </span>
            <span className="hidden lg:inline">{action.linkLabel}</span>
          </span>
        </span>
        <span className="transition group-hover:translate-x-1">
          <ArrowRightIcon width={24} height={24} aria-hidden />
        </span>
      </a>
    );
  });
};
